import { Button, Dialog, DialogTitle, DialogActions, DialogContent, TextField, CircularProgress, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, InputAdornment, IconButton, } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AutoCompleteEfectorFacturacion } from "../../liquidaciones/UI/AutoCompleteEfectorFacturacion";
import ModalAbm from "../../compartidos/abms/ModalAbm";
import { FormNuevoMaterial } from "../Materiales/FormNuevoMaterial";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import moment from "moment";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { startAlerta } from "../../../actions/ui/alertas";
import { NuevaCotizacionExpress, setMaterialCompras, TraerSolicitudTerminada } from "../../../actions/compras/Cotizaciones";
import { Search } from "@material-ui/icons";


export const ModalCotizacionExpress = (props) => {
    const dispatch = useDispatch();
    const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
    const [open, setOpen] = useState(false);
    const { solicitudesPendientesCotizacion } = useSelector((state) => state.compras);
    const cargando = open && solicitudesPendientesCotizacion === 0;
    const [material, setMaterial] = useState();
    const [openMaterial, setMaterialAlta] = useState(false);
    const [info, setInfo] = useState([]);
    const {
        efectorSeleccionado,
    } = useSelector((state) => state.liquidaciones);
    const { materialCompras } = useSelector((state) => state.compras);
    const [confirmarEliminarMaterial, setConfirmarEliminarMaterial] = useState(false);
    const [idSolicitudTerminada, setIdSolicitudTerminada] = useState("")
    console.log(solicitudSeleccionada?.practicas[0]?.materiales)

    if (solicitudSeleccionada?.practicas[0]?.materiales?.length > 0 && info.length === 0) {
        solicitudSeleccionada?.practicas[0]?.materiales?.forEach((item) => {
            let documentacion = {};
            if (item.fechaBaja === null) {
                documentacion = {
                    cantidadCotizada: solicitudSeleccionada?.idPresupuesto !== null ? item.cantidad : item.cantidadCotizada,
                    cantidad: item.cantidad,
                    valorUnitario: solicitudSeleccionada?.idPresupuesto !== null ? item.valorUnitarioPresupuesto : item.valorUnitario,
                    fechaEntrega: item.fechaEntrega,
                    observaciones: item.observaciones,
                    IdDetalleCotizacion: item.idDetalleCotizacion,
                    IdCotizacionCabecera: item.idCotizacionCabecera,
                    idMaterial: item.material?.codigoNum,
                    material: item.material?.descripcion,
                    agregadoCompras: item.agregadoCompras,
                    idEstadoMaterial: item.idEstadoMaterial
                }
                debugger
                info.push(documentacion)
            }
        })
    }
    const handleItemSelect = (item) => {
        setMaterial(item);
        setOpen(true);
    }

    const handleEdit = (item) => {
        let value = info.filter((a) => a.idMaterial === item.idMaterial);
        if (value.length > 0) {
            setInfo(
                info.map((a) => a.idMaterial === item.idMaterial ?
                    {
                        cantidad: item.cantidad,
                        cantidadCotizada: item.cantidadCotizada,
                        valorUnitario: item.valorUnitario,
                        fechaEntrega: item.fechaEntrega,
                        observaciones: item.observaciones,
                        material: a.material,
                        agregadoCompras: item.agregadoCompras,
                        idMaterial: a.idMaterial,
                        idEstadoMaterial: item.idEstadoMaterial
                    }
                    :
                    a
                ))
        }
    }
    const handleEliminar = (item) => {
        var material = info.filter(x => x.idMaterial !== item.idMaterial);
        setInfo(material);
    }
    useEffect(() => {
        if (materialCompras !== null) {
            var material = info.find(x => x.idMaterial === materialCompras.idMaterial);
            if (material === undefined) {
                setInfo(info => info.concat(materialCompras));
            } else {
                dispatch(startAlerta('Ese material ya se encuentra cargado.', "warning", `¡Error!`));
            }
        }
    }, [materialCompras])

    const handleSave = () => {
        debugger
        var tieneValoresVacios = info.filter(x=>x.valorUnitario === undefined);
        if (!efectorSeleccionado) {
            dispatch(startAlerta('Debe seleccionar un efector.', "warning", `¡Error!`))
        }
        else if (!solicitudSeleccionada) {
            dispatch(startAlerta('Debe seleccionar una solicitud.', "warning", `¡Error!`))
        }else if (tieneValoresVacios.length > 0){
            dispatch(startAlerta('Debe ingresar un valor para todos los materiales.', "warning", `¡Error!`))
        } 
        else {
            dispatch(NuevaCotizacionExpress(solicitudSeleccionada.idSolicitud, efectorSeleccionado.idEfectorFacturacion, info))
            dispatch(props.close);
        }
    }
    useEffect(() => {
        setInfo([])
        setMaterialCompras(null);
    }, [dispatch, solicitudSeleccionada?.idSolicitud])

    console.log(info)
    return (
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={props.open}>
            <DialogTitle style={{ textAlign: 'center' }}>Cargar Cotizacion a un prestador</DialogTitle>
            <DialogContent>
                <Grid item xs={12}>
                    <AutoCompleteEfectorFacturacion todos />
                </Grid>
                <Grid item style={{ display: "flex" }}>
                    <Grid item xs={6} style={{ marginLeft: '1rem' }}>
                        <Autocomplete
                            id="BuscadorSolicitudes"
                            loadingText="Buscando..."
                            disabled={idSolicitudTerminada !== ""}
                            open={open}
                            onOpen={() => {
                                setOpen(true);
                            }}
                            onClose={() => {
                                setOpen(false);
                            }}
                            onChange={(event, newValue) => {
                                setSolicitudSeleccionada(newValue);
                            }}
                            getOptionSelected={(option, value) =>
                                option.idSolicitud === value.idSolicitud
                            }
                            getOptionLabel={(option) =>
                                ` ${option.idSolicitud} - ${option.afiliado.apellido_y_nombre} - ${option.tipoSolicitud.descripcionTipo}`
                            }
                            renderOption={(option) => (
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span
                                        style={
                                            { color: "green" }
                                        }
                                    >
                                        {`${option.idSolicitud}`}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: 12,
                                        }}
                                    >
                                        {" "}
                                        {`Id Solicitud: ${option.idSolicitud} - Afiliado: ${option.afiliado?.apellido_y_nombre} - Tipo Solicitud:  ${option.tipoSolicitud.descripcionTipo}`}
                                    </span>
                                </div>
                            )}
                            options={solicitudesPendientesCotizacion}
                            loading={cargando}
                            renderInput={(params) => (
                                <TextField
                                    //onChange={handleInputChange}
                                    style={{
                                        padding: 3,
                                    }}
                                    {...params}
                                    label="Nº Orden - Afiliado"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {cargando ? (
                                                    <CircularProgress color="inherit" size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6} style={{ marginLeft: '1rem' }}>
                        <TextField
                            fullWidth
                            type="number"
                            label='N° Solicitud Terminada'
                            name='idSolicitudTerminada'
                            value={idSolicitudTerminada}
                            autoComplete="off"
                            onChange={(e) => setIdSolicitudTerminada(e.target.value)}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Buscar"
                                            onClick={() => {
                                                dispatch(TraerSolicitudTerminada(idSolicitudTerminada, setSolicitudSeleccionada));
                                            }}
                                        >
                                            <Search />
                                        </IconButton>
                                    </InputAdornment>
                            }}

                        />
                    </Grid>
                </Grid>
                {solicitudSeleccionada &&
                    (<Grid>
                        <ModalAbm title="Agregar Material" open={openMaterial} setOpen={setMaterialAlta}>
                            <FormNuevoMaterial material={null} idSolicitud={solicitudSeleccionada.idSolicitud} cerrarModal={() => setMaterialAlta(false)} />
                        </ModalAbm>
                        <ModalAbm title="Modificar Material" open={open} setOpen={setOpen}>
                            <FormNuevoMaterial material={material} handleEdit={handleEdit} cerrarModal={() => setOpen(false)} />
                        </ModalAbm>
                        <Button variant="contained" color="primary" onClick={() => setMaterialAlta(true)} style={{ float: "right", margin: "1rem" }}>+ Agregar Material</Button>
                        {/* <Button variant="contained" color="primary" onClick={() => setDocumentacionAlta(true)} style={{ float: "right", margin: "1rem" }}>Documentacion</Button> */}
                        <TableContainer style={{ overflowX: "auto", marginTop: '1rem', padding: '0.5rem' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Material</TableCell>
                                        <TableCell>Cantidad</TableCell>
                                        <TableCell>Cantidad Cotizada</TableCell>
                                        <TableCell>Precio Unitario</TableCell>
                                        <TableCell>Fecha de Entrega</TableCell>
                                        <TableCell>Observaciones</TableCell>
                                        <TableCell>Precio Total</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {info.length > 0 && (
                                        info.map((a) => (
                                            <TableRow key={a.idDetalleCotizacion}>
                                                <Tooltip title={a.agregadoCompras === true ? 'Agregado en Compras' : ''}>
                                                    <TableCell style={{ color: a.agregadoCompras === true ? 'green' : 'black' }}>
                                                        {a.material}
                                                    </TableCell>
                                                </Tooltip>
                                                <TableCell>{a.cantidad}</TableCell>
                                                <TableCell>{a.cantidadCotizada ? a.cantidadCotizada : '-'}</TableCell>
                                                <TableCell>{a.valorUnitario ? a.valorUnitario : '-'}</TableCell>
                                                <TableCell>{a.fechaEntrega ? moment(a.fechaEntrega).format("DD/MM/yyyy") : '-'}</TableCell>
                                                <TableCell>{a.observaciones ? a.observaciones : '-'}</TableCell>
                                                <TableCell>${a.cantidadCotizada * a.valorUnitario} </TableCell>
                                                <TableCell><Button tabIndex="-1" onClick={() => setConfirmarEliminarMaterial(true)}><DeleteOutlineOutlinedIcon style={{ color: 'red' }} /></Button>
                                                    <AlertFinalizadoStepper
                                                        open={confirmarEliminarMaterial}
                                                        pregunta={"Eliminar Material"}
                                                        dialogText={`Esta seguro de eliminar el material?`}
                                                        buttonCancel={"Cancelar"}
                                                        buttonSubmit={"Confirmar"}
                                                        handleClose={() => setConfirmarEliminarMaterial(false)}
                                                        handleSend={() => {
                                                            handleEliminar(a);
                                                            setConfirmarEliminarMaterial(false);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell><Button onClick={() => handleItemSelect(a)}><EditIcon /></Button></TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>)}
            </DialogContent>
            <DialogActions style={{ display: 'flex', margin: 'auto' }}>
                <Button color="inherit" variant="contained"
                    onClick={() => {
                        dispatch(props.close);
                    }}>
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleSave}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    )
}